import React from 'react';
import { cn } from '@/utils/cn';

export function ProjectHistoryQuickFilters() {
  const filters = [
    { label: 'Hôm nay', icon: 'ri-calendar-check-line' },
    { label: '7 ngày qua', icon: 'ri-calendar-event-line' },
    { label: '30 ngày qua', icon: 'ri-calendar-2-line', active: true },
    { label: 'Tùy chỉnh', icon: 'ri-calendar-settings-line' },
  ];

  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <h3 className="text-sm font-normal text-slate-900 border-b border-slate-50 pb-2">Thống kê hoạt động</h3>
      <div className="space-y-2">
        {filters.map((f, idx) => (
          <button 
            key={idx} 
            className={cn(
              "w-full flex items-center gap-3 p-2.5 rounded-md text-xs font-normal transition-all border",
              f.active 
                ? "bg-emerald-50 border-emerald-100 text-emerald-600 " 
                : "bg-slate-50/50 border-transparent text-slate-500 hover:bg-slate-50"
            )}
          >
            <i className={cn(f.icon, "text-base")} />
            <span>{f.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
